import { useCallback, useMemo } from 'react';
import useGlobals from './useGlobals';
import { ModalData } from '../Types';
import { setModal } from '../Store/Actions/modalActions';
import { connectorService } from '../Services/connectorService';
import { setListReloadType } from '../Store/Actions/environmentActions';
import { PaginationListType } from '../Types/PaginationParams';

const usePromptFunctions = () => {
    const { handleNavigate, userSettings, i18n, dispatch, windowWidth, getBreakpoint } = useGlobals();

    const deletePromptfunction = useCallback(
        (identifier: string) => {
            if (!userSettings.isLoggedIn) return;

            connectorService.deleteConnector(identifier).then(() => {
                dispatch(setListReloadType(PaginationListType.Connectors));
            });
        },
        [userSettings.isLoggedIn, dispatch],
    );

    const handleOpenConfirmDialog = useCallback(
        (apiKeyIdentifier: string) => {
            dispatch(
                setModal({
                    state: 'open',
                    title: i18n.translate({ id: 'promptFunctionDelete.title', sourceName: 'PromptFunctions' }),
                    content: i18n.translate({ id: 'promptFunctionDelete.text', sourceName: 'PromptFunctions' }),
                    modalSize: 'small',
                    closeOnAction: true,
                    showCloseButton: false,
                    buttonRightAction: () => deletePromptfunction(apiKeyIdentifier),
                } as ModalData),
            );
        },
        [dispatch, deletePromptfunction, i18n],
    );

    const PromptFunctionsActions = useMemo(
        () => ({
            deletePromptfunction,
            handleOpenConfirmDialog,
        }),
        [deletePromptfunction, handleOpenConfirmDialog],
    );

    return {
        PromptFunctionsActions,
        handleNavigate,
        i18n,
        windowWidth,
        getBreakpoint,
    };
};

export default usePromptFunctions;
